module.exports = __webpack_public_path__ + "assets/b06f1777e36ba1067aee634186049010.mp3";